export default function GameEditLinks({ links = {}, onChange }) {
  const LINK_KEYS = [
    { key: 'homepage', label: '공식 홈페이지' },
    { key: 'forum', label: '커뮤니티 포럼' },
    { key: 'discord', label: '디스코드' },
    { key: 'twitter', label: '트위터/X' },
    { key: 'youtube', label: '유튜브' },
  ];

  const handleInput = (key, value) => {
    onChange({
      ...links,
      [key]: value
    });
  };

  return (
    <div className="bg-neutral-800 p-4 rounded">
      <h4 className="text-md font-semibold mb-2 text-white">관련 링크</h4>
      <div className="space-y-2">
        {LINK_KEYS.map(({ key, label }) => (
          <div key={key} className="flex items-center gap-3">
            <label className="w-32 text-sm text-gray-300">{label}</label>
            <input
              type="url"
              value={links[key] || ''}
              onChange={e => handleInput(key, e.target.value)}
              className="flex-1 p-1 rounded bg-neutral-700 border border-gray-600 text-white text-sm"
              placeholder={`${label} 링크 입력`}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
